import React from "react";
import { ManageDocketTemplateFilterRootContext } from "./context";

export const useManageDocketTemplateFilterRootContextProvider = () => {
  const context = React.useContext(ManageDocketTemplateFilterRootContext);
  if (!context) {
    throw new Error(
      "useManageDocketTemplateFilterRootContextProvider must be used within a ManageDocketTemplateFilterRootContextProvider"
    );
  }
  return context;
};
